import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ICompanyAreaResponse } from '../interfaces/company-area.interface';
import { IResponseData, IResponseListData, IResponseListDataPaginate } from '../interfaces/response-data.interface';
import {
  IFilterUserRequest, IOfficeUser, IResendPassword, IUserByIdResponse, IUserCreateRequest,
  IUserQueryRequest, IUserQueryResponse, IUserType
} from '../interfaces/user.interface';
import { RetornaDadosRequest } from '../helpers/retorna-dados-request';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  resendPasswordRequest: IResendPassword;

  constructor(private http: HttpClient, private retornoStatus : RetornaDadosRequest) { }

  getAll(request: IUserQueryRequest): Observable<IResponseListDataPaginate<IUserQueryResponse>> {
    let params = new HttpParams();
    if (request.userTypeId !== '' && request.userTypeId !== undefined && request.userTypeId !== null) {
      params = params.append('userTypeId', request.userTypeId);
    }
    if (request.name !== '' && request.name !== undefined && request.name !== null) {
      params = params.append('name', request.name);
    }
    if (request.email !== '' && request.email !== undefined && request.email !== null) {
      params = params.append('email', request.email);
    }
    if (request.cpfcnpj !== '' && request.cpfcnpj !== undefined && request.cpfcnpj !== null) {
      params = params.append('cpfcnpj', request.cpfcnpj);
    }

    if (request.profileId !== '' && request.profileId !== undefined && request.profileId !== null) {
      params = params.append('profileId', request.profileId);
    }
    if (request.status !== '' && request.status !== undefined && request.status !== null) {
      params = params.append('status', request.status);
    }
    if (request.page !== undefined) {
      params = params.append('page', request.page.toString());
    }
    if (request.pageSize !== undefined) {
      params = params.append('pageSize', request.pageSize.toString());
    }
    return this.http.get<IResponseListDataPaginate<IUserQueryResponse>>(`${environment.urlApi}/User/GetByFilter`, { params });
  }

  getAllCompanyArea(): Observable<IResponseListData<ICompanyAreaResponse>> {
    return this.http.get<IResponseListData<ICompanyAreaResponse>>(`${environment.urlApi}/User/GetAllCompanyArea`);
  }

  getOfficeUsers(): Observable<IResponseListData<IOfficeUser>> {
    return this.http.get<IResponseListData<IOfficeUser>>(`${environment.urlApi}/GetOfficeUsers`);
  }

  GetAllUserTypes(): Observable<IResponseListData<IUserType>> {
    return this.http.get<IResponseListData<IUserType>>(`${environment.urlApi}/User/GetAllUserTypes`);
  }

  GetAllUsers(): Observable<IResponseListData<IUserType>> {
    return this.http.get<IResponseListData<IUserType>>(`${environment.urlApi}/User/GetAllUsers`);
  }

  getToName(request: IFilterUserRequest): Observable<any> {
    let params = new HttpParams();
    if (request.name !== '' && request.name !== undefined) {
      params = params.append('name', request.name);
    }
    return this.http.get<any>(`${environment.urlApi}/User/GetToName`, { params });
  }

  getToEmail(request: IFilterUserRequest): Observable<any> {
    let params = new HttpParams();
    if (request.email !== '' && request.email !== undefined) {
      params = params.append('email', request.email);
    }
    return this.http.get<any>(`${environment.urlApi}/User/GetToEmail`, { params });
  }

	resendPassword(id: string): Observable<any> {
		this.resendPasswordRequest = { id };
		return this.http.post<any>(`${environment.urlApi}/ResendPassword`, this.resendPasswordRequest);
	  }

  getLoggedUser(): Observable<IResponseData<any>> {
    return this.http.get<IResponseData<any>>(`${environment.urlApi}/User/GetLoggedUser`);
  }

  getUserById(id?: number): Observable<IResponseData<any>> {
    return this.http.get<IResponseData<any>>(`${environment.urlApi}/User/GetUserById?id=${id}`);
  }

  update(request: IUserCreateRequest): Observable<any> {
    return this.http.put<any>(`${environment.urlApi}/PutUser`, request);
  }

  post(request: IUserCreateRequest): Observable<any> {
    return this.http.post<any>(`${environment.urlApi}/PostUser`, request);
  }

  getUsersByTypeId(userTypeId: number): Observable<IResponseListData<IUserType>> {
    let params = new HttpParams();
    params = params.append('userTypeId', userTypeId?.toString());
    return this.http.get<IResponseListData<IUserType>>(`${environment.urlApi}/User/GetUsersByTypeId`, { params });
  }

  changePassword(request: IUserCreateRequest): Observable<any> {
    return this.http.put<any>(`${environment.urlApi}/changePassword`, request);
  }
}
